import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Status } from 'components';

// Styles
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const StatusPresent = ({
  discount, statusText, price, emoji = '', indSaleConnected = false,
}) => (
  <Status className={['attention', 'compact', cx('status')]} emoji={emoji || (discount ? 'present' : 'sharing')}>
    <div className={cx('statusContent')}>
      {statusText?.title && (
        <div
          className={cx('title')}
          dangerouslySetInnerHTML={{ __html: statusText.title }}
        />
      )}

      {statusText?.description && (
        <div
          className={cx('description')}
          dangerouslySetInnerHTML={{ __html: statusText.description }}
        />
      )}

      {statusText?.additionalDescription && (
        <div
          className={cx('additionalDescription')}
          dangerouslySetInnerHTML={{ __html: statusText.additionalDescription }}
        />
      )}

      <div className={cx('price')}>
        {indSaleConnected ? (
          <>
            <span
              dangerouslySetInnerHTML={{ __html: price }}
              className={cx('lineThrough')}
            />
            <span>Бесплатно</span>
          </>
        ) : (price && discount ? (
          <>
            <span
              dangerouslySetInnerHTML={{ __html: price }}
              className={cx('lineThrough')}
            />
            <span dangerouslySetInnerHTML={{ __html: discount }} />
          </>
        ) : (
          <span dangerouslySetInnerHTML={{ __html: price }} />
        ))}
      </div>
    </div>
  </Status>
);

StatusPresent.propTypes = {
  discount: PropTypes.string,
  price: PropTypes.string,
  statusText: PropTypes.object,
  emoji: PropTypes.string,
  indSaleConnected: PropTypes.bool,
};

export default StatusPresent;
